import './AbandonedRequests.css';
import Table from 'react-bootstrap/Table';
import AbandonedRequestsRow from '../AbandonedRequestsRow/AbandonedRequestsRow';
import {QuestionCircle} from 'react-bootstrap-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useRef } from 'react';

function AbandonedRequests(props){
      const dispatch = useDispatch();
        const request = useSelector((store) => store.requestReducer.abandoned);
     const requestNewest = useSelector((store) => store.requestNewestReducer.abandoned);
    const requestName = useSelector((store) => store.requestNameReducer.abandoned);       
    const [searchTerm, setSearchTerm ] = useState("");
    const [searchResults,setSearchResult] = useState([]);
    const inputEl = useRef("");
          const searchHandler = (searchTerm) =>{
        setSearchTerm(searchTerm);
        if(searchTerm !==""){
            const newClientList = request.filter((request)=>{
              return Object.values(request).join(" ").toLowerCase().includes(searchTerm.toLowerCase());
            })
            setSearchResult(newClientList);
            console.log("test"+searchResults);
        }
        else{
            setSearchResult(request);
             console.log("test"+searchResults);
        }
        }

    const getSearchTerm = () =>{
      
        searchHandler(inputEl.current.value);
    }
         useEffect(() => {
 

  
  }, []);
    return(
        <>
                <input ref={inputEl} size="40" type="text" value={searchTerm} onChange={getSearchTerm} placeholder="type to search"></input> <button onClick ={(e) => (setSearchTerm(""))}>CLEAR</button>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th className="text-center">
                        Referral Date
                    </th>
                    <th className="text-center">
                        Referral Agency
                    </th>
                    <th className="text-center">
                        Client Name
                    </th>
                    <th className="text-center">
                        Notes
                    </th>
                    <th className="text-center">
                        Actions
                    </th>
                </tr>
            </thead>
                        {searchTerm.length<1?

            <>
            <>
            {props.sortValue == 0 ?
            <AbandonedRequestsRow searchResults = {requestNewest}/>
            :
            <>
                {props.sortValue == 1 ?
                    <AbandonedRequestsRow searchResults = {request}/>
                    :
                    <>
                        {props.sortValue == 2?
                        <AbandonedRequestsRow searchResults = {requestName}/>
                            :
                            <> </> 
                        }
                    </>
                }
            </>
            }

            </>
            </>
 
            :
             <AbandonedRequestsRow
            
             searchResults = {searchResults}
        
             
             />
            
            }
        </Table>
        </>
    );
}

export default AbandonedRequests;